import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = { class: "user-dropdown" }

import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import locale from 'ant-design-vue/es/locale/zh_CN'
import {
  DashboardOutlined,
  ApartmentOutlined,
  SettingOutlined,
  CodeOutlined,
  UserOutlined,
  LogoutOutlined,
  DownOutlined
} from '@ant-design/icons-vue'

import { computed } from 'vue'

// 判断是否为登录页面

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const selectedTopKeys = ref(['dashboard'])
const selectedSideKeys = ref(['overview'])
const openKeys = ref(['access', 'ops'])

// 顶部菜单与路由联动
watch(
  () => route.path,
  (path) => {
    if (path === '/' || path === '') selectedTopKeys.value = ['dashboard']
    else if (path.startsWith('/network')) selectedTopKeys.value = ['network']
    else if (path.startsWith('/system')) selectedTopKeys.value = ['system']
    else if (path.startsWith('/lowcode')) selectedTopKeys.value = ['lowcode']
    else if (path.startsWith('/profile')) selectedTopKeys.value = ['profile']
    else selectedTopKeys.value = ['dashboard']

    // 侧边栏高亮和展开
    if (path === '/network/overview') {
      selectedSideKeys.value = ['overview']
      openKeys.value = []
    } else if (path === '/network/device-mgr') {
      selectedSideKeys.value = ['device-mgr']
      openKeys.value = ['access']
    } else if (path === '/network/model') {
      selectedSideKeys.value = ['model']
      openKeys.value = ['access']
    } else if (path === '/network/product-mgr') {
      selectedSideKeys.value = ['product-mgr']
      openKeys.value = ['access']
    } else if (path === '/network/product-cat') {
      selectedSideKeys.value = ['product-cat']
      openKeys.value = ['access']
    } else if (path === '/network/gateway') {
      selectedSideKeys.value = ['gateway']
      openKeys.value = ['access']
    } else if (path === '/network/script') {
      selectedSideKeys.value = ['script']
      openKeys.value = ['access']
    } else if (path === '/network/ota') {
      selectedSideKeys.value = ['ota']
      openKeys.value = ['ops']
    } else {
      selectedSideKeys.value = []
      openKeys.value = []
    }
  },
  { immediate: true }
)

function onTopMenuClick({ key }: { key: string }) {
  if (key === 'dashboard') router.push('/')
  else if (key === 'network') router.push('/network/overview')
  else if (key === 'system') router.push('/system/systemConfig/user-mgr')
  else if (key === 'lowcode') router.push('/lowcode')
  else if (key === 'profile') router.push('/profile')
  else if (key === 'logout') {
    // 清除登录状态
    localStorage.removeItem('token')
    // 跳转到登录页
    router.push('/login')
  }
}

function onSelectSideMenu(keys: string[]) {
  selectedSideKeys.value = keys
  // 路由跳转
  if (keys[0] === 'overview') router.push('/network/overview')
  else if (keys[0] === 'device-mgr') router.push('/network/device-mgr')
  else if (keys[0] === 'model') router.push('/network/model')
  else if (keys[0] === 'product-mgr') router.push('/network/product-mgr')
  else if (keys[0] === 'product-cat') router.push('/network/product-cat')
  else if (keys[0] === 'gateway') router.push('/network/gateway')
  else if (keys[0] === 'script') router.push('/network/script')
  else if (keys[0] === 'ota') router.push('/network/ota')
}

const isLoginPage = computed(() => route.path === '/login')

// 根据是否为登录页面设置内容区样式
const contentStyle = computed(() => ({
  padding: isLoginPage.value ? 0 : '24px',
  minHeight: '100vh',
  background: isLoginPage.value ? 'transparent' : '#f0f2f5'
}))

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(locale) }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            (!isLoginPage.value)
              ? (_openBlock(), _createBlock(_component_a_layout_header, {
                  key: 0,
                  class: "header"
                }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "logo" }, "迈睿达", -1)),
                    _createVNode(_component_a_menu, {
                      selectedKeys: selectedTopKeys.value,
                      theme: "dark",
                      mode: "horizontal",
                      style: { lineHeight: '64px' },
                      onClick: onTopMenuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, { key: "dashboard" }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(DashboardOutlined))
                          ]),
                          default: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createTextVNode(" 控制台 "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, { key: "network" }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(ApartmentOutlined))
                          ]),
                          default: _withCtx(() => [
                            _cache[2] || (_cache[2] = _createTextVNode(" 智联网 "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, { key: "system" }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(SettingOutlined))
                          ]),
                          default: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createTextVNode(" 系统管理 "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, { key: "lowcode" }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(CodeOutlined))
                          ]),
                          default: _withCtx(() => [
                            _cache[4] || (_cache[4] = _createTextVNode(" 低代码 "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["selectedKeys"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_a_dropdown, null, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, { onClick: onTopMenuClick }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, { key: "profile" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(UserOutlined)),
                                  _cache[6] || (_cache[6] = _createTextVNode(" 个人中心 "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_menu_item, { key: "logout" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(LogoutOutlined)),
                                  _cache[7] || (_cache[7] = _createTextVNode(" 退出登录 "))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_3, [
                            _cache[5] || (_cache[5] = _createTextVNode(" administrator ")),
                            _createVNode(_unref(DownOutlined))
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_layout, null, {
              default: _withCtx(() => [
                (selectedTopKeys.value[0] === 'network' && !isLoginPage.value)
                  ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                      key: 0,
                      width: "200",
                      class: "sider",
                      style: {background: '#fff'}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu, {
                          mode: "inline",
                          selectedKeys: selectedSideKeys.value,
                          openKeys: openKeys.value,
                          "onUpdate:selectedKeys": onSelectSideMenu,
                          "onUpdate:openKeys": _cache[0] || (_cache[0] = (val) => openKeys.value = val),
                          style: {"height":"100%","border-right":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_item, { key: "overview" }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(DashboardOutlined))
                              ]),
                              default: _withCtx(() => [
                                _cache[9] || (_cache[9] = _createTextVNode(" 智联网概况 "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_sub_menu, { key: "access" }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(SettingOutlined))
                              ]),
                              title: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("设备接入")
                              ])),
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, { key: "device-mgr" }, {
                                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode("设备管理")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, { key: "model" }, {
                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode("通用物模型")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, { key: "product-mgr" }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode("产品管理")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, { key: "product-cat" }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode("产品品类")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, { key: "gateway" }, {
                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createTextVNode("协议网关")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, { key: "script" }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode("协议脚本")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_sub_menu, { key: "ops" }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(UserOutlined))
                              ]),
                              title: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("运维管理")
                              ])),
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, { key: "ota" }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("ota升级")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["selectedKeys", "openKeys"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_layout_content, {
                  class: _normalizeClass({'login-content': isLoginPage.value}),
                  style: _normalizeStyle(contentStyle.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                }, 8, ["class", "style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})